export default __webpack_public_path__ + "static/media/partners.00c85956.jpg";